import { FormInstance } from 'antd';
import { useState, useEffect } from 'react';
import { Form } from '~/components';
import useMutableCallback from './useMutableCallback';

export type UseStatefulFormReturnTyep<Values = any> = {
  form: FormInstance<Values>;
  formState: Values | undefined;
  handleFormChange: (newValues: Values) => void;
};

export const useStatefulForm = <Values = any>(
  initialState?: Values
): UseStatefulFormReturnTyep<Values> => {
  const [form] = Form.useForm<Values>();

  // NOTE: setFormState is used only internally in this hook. Pass handleFormChange to onValuesChange Form prop to update formState
  const [formState, setFormState] = useState<Values>();
  const handleFormChange = (newValues: Values) => {
    setFormState(newValues);
  };
  const setInitialState = useMutableCallback(() => {
    if (initialState && !formState) {
      setFormState(initialState);
      form.setFieldsValue(initialState as any);
    }
  });

  useEffect(() => {
    setInitialState();
  }, [setInitialState, initialState]);

  return {
    form,
    formState,
    handleFormChange,
  };
};
